import styled from 'styled-components';

import { CrossIcon, SearchIcon } from '../../../assets';
import { ThemeProp } from '../../../theme/Themes';
import { setSVGChildColors } from '../../../utils/Listings';
import Input from '..';

interface IsFocusable {
  $focused?: boolean;
}

interface SearchContainerProps extends IsFocusable {
  $desktopWidth?: string;
  $maxDesktopWidth?: string;
  $mobileTabletWidth?: string;
  $maxMobileTabletWidth?: string;
  $autoHeight?: boolean;
  $mobileHeight?: string;
  $contentRightWidth?: string;
}

export const SearchContainer = styled.div<SearchContainerProps>`
  display: flex;
  position: relative;
  width: ${(props: SearchContainerProps) => props.$desktopWidth || '19rem'};
  max-width: ${(props: SearchContainerProps) => props.$maxDesktopWidth || 'unset'};
  height: ${(props: SearchContainerProps) => (props.$autoHeight ? 'auto' : '2rem')};
  flex: 1;

  @media (max-width: ${(props: any) => props.theme.breakpoints.tablet}) {
    width: ${(props: SearchContainerProps) => props.$mobileTabletWidth || '100%'};
    max-width: unset;
    height: ${(props: SearchContainerProps) => (props.$autoHeight ? 'auto' : props.$mobileHeight ?? '2.25rem')};
  }
`;

export const StyledSearchIcon = styled(SearchIcon)`
  width: 1.125rem;
  height: 1.125rem;
  svg,
  path,
  circle,
  rect {
    stroke: ${({ theme }: ThemeProp) => theme.colors.greyscale.c100};
  }

  @media (max-width: ${(props: any) => props.theme.breakpoints.mobile}) {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

interface SearchButtonProps extends IsFocusable {}

export const SearchButton = styled.button<SearchButtonProps>`
  margin: 0;
  padding: 0;
  font-size: 0;
  line-height: 0;
  width: 2.5rem;
  height: 2.5rem;
  cursor: pointer;
  border: 0;
  border-radius: 50%;
  background: ${(props: any) => (props.$focused ? 'transparent' : props.theme.colors.greyscale.c900)};
  box-shadow: ${(props: any) => (props.$focused ? 'none' : props.theme.shadows.secondary)};
  &:hover {
    background: ${(props) => (props.$focused ? 'transparent' : props.theme.colors.primary.c800)};
    ${(props: SearchButtonProps & ThemeProp) => !props.$focused && setSVGChildColors(props.theme.colors.primary.c200)}
  }
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    box-shadow: unset;
    stroke: ${({ theme }: ThemeProp) => theme.colors.primary.c050};
  }
`;

export const StyledSearchInput = styled(Input).attrs((props) => ({
  ...props,
  noMarginBottom: true,
  css: {
    '& .nextui-input-container': {
      borderRadius: '3.125rem !important',
      backgroundColor: props.theme.colors.greyscale.c900,
      overflow: 'hidden',
      border: `1px solid ${props.theme.colors.neutrals.c300}`,
    },
    '& .nextui-input-wrapper': {
      background: 'transparent !important',
    },
    '& .nextui-input-container--hover': {
      border: `1px solid ${props.theme.colors.neutrals.c500}`,
    },
    '& .nextui-input': {
      fontSize: props.theme.fontVariants.desktop.body2.fontSize,
      color: `${props.theme.colors.neutrals.c900} !important`,
      margin: '0',
      paddingRight: '0.5rem',
    },
    '& .nextui-input-main-container': {
      marginBottom: '0 !important',
    },
    '& .nextui-input-label--left': {
      background: 'transparent',
      paddingRight: '0.5rem',
    },
    '& .nextui-input-content--right': {
      width: props.$contentRightWidth ?? '0.5rem',
    },
    ...props.css,
  },
}))`
  && {
    margin: 0;
    border-radius: ${(props: ThemeProp) => props.theme.borderRadius};
  }
  & input::placeholder {
    color: ${(props: ThemeProp) => props.theme.colors.neutrals.c500};
  }
`;

export const ClearButtonIcon = styled(CrossIcon)`
  width: 0.875rem;
  height: 0.875rem;
  stroke: ${(props: ThemeProp) => props.theme.colors.white};
`;

export const ClearButtonContainer = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.75rem;
  font-size: 0;
  cursor: pointer;
  line-height: 0;
`;

export const InputContainer = styled.div`
  margin-top: 0.5rem;

  .nextui-input-main-container {
    margin-bottom: 0;
  }
`;

export const ContentRightWrapper = styled.div<{ $addRightPadding?: boolean }>`
  margin-right: ${(props) => (props.$addRightPadding ? '1.5rem' : '0')};
`;
